import * as t from 'ts-codec';
import { date, ObjectId, Resource, ResourceId } from '@journeyapps-labs/micro-codecs';
import { ResourceImages } from './types-resources.js';
export var GroupProfileRole;
(function (GroupProfileRole) {
    GroupProfileRole["OWNER"] = "owner";
    GroupProfileRole["MEMBER"] = "member";
})(GroupProfileRole || (GroupProfileRole = {}));
export var GroupUserStatus;
(function (GroupUserStatus) {
    GroupUserStatus["INVITED"] = "invited";
    GroupUserStatus["ACCEPTED"] = "accepted";
})(GroupUserStatus || (GroupUserStatus = {}));
export var AbstractGroupType;
(function (AbstractGroupType) {
    AbstractGroupType["GROUP"] = "group";
    AbstractGroupType["PACK"] = "pack";
})(AbstractGroupType || (AbstractGroupType = {}));
export const GroupUser = t.object({
    user_id: ObjectId,
    role: t.Enum(GroupProfileRole),
    join_date: date.optional()
});
export const AbstractGroup = t
    .object({
    name: t.string,
    about: t.string
})
    .and(ResourceImages);
export const Group = AbstractGroup.and(t.object({
    type: t.literal(AbstractGroupType.GROUP),
    public: t.literal(true)
}));
export const GroupResource = Group.and(ResourceId);
// !---------- PACKS ---------
export const PackRole = Resource.and(t.object({
    label: t.string
}));
export const Pack = AbstractGroup.and(t.object({
    type: t.literal(AbstractGroupType.PACK),
    public: t.boolean,
    custom_roles: t.array(PackRole)
}));
export const PackResource = Pack.and(ResourceId);
